.wrapper {
	position: fixed;
	inset: 0;
	background-color: black;
	background-image: url("../assets/menu_card.png");
	background-position: center;
	background-size: cover;
	padding: 50px 0;
	display: flex;
	flex-direction: column;
	align-items: center;
}

.prompt {
	margin: auto;
	display: flex;
	align-items: flex-end;
	gap: 10px;
	background-color: rgba(0, 0, 0, 0.5);
	border: 1px solid rgba(0, 0, 0, 0.3);
	backdrop-filter: blur(10px);
	border-radius: 10px;
	padding: 10px;
	box-shadow: 0 3px 10px rgba(0, 0, 0, 0.5);
}

.inputWrapper {
	display: flex;
	flex-direction: column;
	gap: 10px;
}

.label {
	font-weight: bold;
}

.input {
	height: 40px;
	padding: 0 15px;
	border: 1px solid rgba(255, 255, 255, 0.3);
	border-radius: 10px;
	width: 20rem;
}

.submit {
	width: 40px;
	height: 40px;
	background-color: rgba(255, 255, 255, 0.15);
	border: 1px solid rgba(255, 255, 255, 0.3);
	border-radius: 50%;
	background-image: url("../assets/arrow.svg");
	background-size: 24px;
	background-position: center;
	background-repeat: no-repeat;
}
